/**
 * Übersetzungen der Zustellweg-Auswahl (`SmtpDeliveryModeSelect`).
 *
 * Eigene Datei statt Erweiterung von `accessEmailTranslations.ts`: Jene führt nur Deutsch und
 * Englisch, weil ihr Panel nur in mQmarketing und mQguard läuft. Die Zustellweg-Auswahl nutzt
 * zusätzlich my-vitalteam und braucht deshalb alle fünf Sprachen der Consumer.
 */

export const sharedSmtpDeliveryModeDe = {
  "SmtpDeliveryMode.Label": "Zustellweg",
  "SmtpDeliveryMode.Account": "eigenes E-Mail-Konto",
  "SmtpDeliveryMode.AccountHint": "Versand über das Postfach eines echten E-Mail-Kontos: Benutzer ist die Adresse selbst, üblicher Port 465.",
  "SmtpDeliveryMode.AccountUserPlaceholder": "E-Mail-Adresse des Postfachs",
  "SmtpDeliveryMode.Relay": "SMTP-Relay",
  "SmtpDeliveryMode.RelayHint": "Versanddienst mit eigenen Serverdaten: Benutzer ist die Kontokennung des Anbieters, üblicher Port 587.",
  "SmtpDeliveryMode.RelayUserPlaceholder": "Kontokennung beim Anbieter",
  "SmtpDeliveryMode.Brevo": "Brevo",
  "SmtpDeliveryMode.BrevoHint": "Serverdaten stehen fest; als Passwort dient der SMTP-Schlüssel aus dem Brevo-Konto.",
  "SmtpDeliveryMode.BrevoKeysLink": "SMTP-Schlüssel in Brevo",
} as const;

export const sharedSmtpDeliveryModeEn = {
  "SmtpDeliveryMode.Label": "Delivery method",
  "SmtpDeliveryMode.Account": "Own mailbox",
  "SmtpDeliveryMode.AccountHint": "Send through the mailbox of a real email account: the user is the address itself, port 465 is usual.",
  "SmtpDeliveryMode.AccountUserPlaceholder": "Email address of the mailbox",
  "SmtpDeliveryMode.Relay": "SMTP relay",
  "SmtpDeliveryMode.RelayHint": "Relay service with your own server details: the user is the provider's account identifier, port 587 is usual.",
  "SmtpDeliveryMode.RelayUserPlaceholder": "Account identifier at the provider",
  "SmtpDeliveryMode.Brevo": "Brevo",
  "SmtpDeliveryMode.BrevoHint": "Server details are fixed; use the SMTP key from your Brevo account as the password.",
  "SmtpDeliveryMode.BrevoKeysLink": "SMTP keys in Brevo",
} as const;

export const sharedSmtpDeliveryModeRu = {
  "SmtpDeliveryMode.Label": "Способ отправки",
  "SmtpDeliveryMode.Account": "Собственный почтовый ящик",
  "SmtpDeliveryMode.AccountHint": "Отправка через почтовый ящик реальной учётной записи: пользователь — сам адрес, обычный порт 465.",
  "SmtpDeliveryMode.AccountUserPlaceholder": "Адрес электронной почты ящика",
  "SmtpDeliveryMode.Relay": "SMTP-ретранслятор",
  "SmtpDeliveryMode.RelayHint": "Служба отправки с собственными данными сервера: пользователь — идентификатор аккаунта у провайдера, обычный порт 587.",
  "SmtpDeliveryMode.RelayUserPlaceholder": "Идентификатор аккаунта у провайдера",
  "SmtpDeliveryMode.Brevo": "Brevo",
  "SmtpDeliveryMode.BrevoHint": "Данные сервера заданы; паролем служит SMTP-ключ из аккаунта Brevo.",
  "SmtpDeliveryMode.BrevoKeysLink": "SMTP-ключи в Brevo",
} as const;

export const sharedSmtpDeliveryModeUk = {
  "SmtpDeliveryMode.Label": "Спосіб надсилання",
  "SmtpDeliveryMode.Account": "Власна поштова скринька",
  "SmtpDeliveryMode.AccountHint": "Надсилання через скриньку справжнього облікового запису: користувач — сама адреса, звичний порт 465.",
  "SmtpDeliveryMode.AccountUserPlaceholder": "Адреса електронної пошти скриньки",
  "SmtpDeliveryMode.Relay": "SMTP-ретранслятор",
  "SmtpDeliveryMode.RelayHint": "Служба надсилання з власними даними сервера: користувач — ідентифікатор облікового запису в провайдера, звичний порт 587.",
  "SmtpDeliveryMode.RelayUserPlaceholder": "Ідентифікатор облікового запису в провайдера",
  "SmtpDeliveryMode.Brevo": "Brevo",
  "SmtpDeliveryMode.BrevoHint": "Дані сервера фіксовані; паролем є SMTP-ключ з облікового запису Brevo.",
  "SmtpDeliveryMode.BrevoKeysLink": "SMTP-ключі в Brevo",
} as const;

export const sharedSmtpDeliveryModeIt = {
  "SmtpDeliveryMode.Label": "Metodo di invio",
  "SmtpDeliveryMode.Account": "Casella di posta propria",
  "SmtpDeliveryMode.AccountHint": "Invio tramite la casella di un account di posta reale: l'utente è l'indirizzo stesso, porta abituale 465.",
  "SmtpDeliveryMode.AccountUserPlaceholder": "Indirizzo email della casella",
  "SmtpDeliveryMode.Relay": "Relay SMTP",
  "SmtpDeliveryMode.RelayHint": "Servizio di invio con dati del server propri: l'utente è l'identificativo del conto presso il provider, porta abituale 587.",
  "SmtpDeliveryMode.RelayUserPlaceholder": "Identificativo del conto presso il provider",
  "SmtpDeliveryMode.Brevo": "Brevo",
  "SmtpDeliveryMode.BrevoHint": "I dati del server sono fissi; come password si usa la chiave SMTP dell'account Brevo.",
  "SmtpDeliveryMode.BrevoKeysLink": "Chiavi SMTP in Brevo",
} as const;

export const sharedSmtpDeliveryModeTranslations = {
  de: sharedSmtpDeliveryModeDe,
  en: sharedSmtpDeliveryModeEn,
  ru: sharedSmtpDeliveryModeRu,
  uk: sharedSmtpDeliveryModeUk,
  it: sharedSmtpDeliveryModeIt,
} as const;

export type SharedSmtpDeliveryModeLang = keyof typeof sharedSmtpDeliveryModeTranslations;
export type SharedSmtpDeliveryModeKey = keyof typeof sharedSmtpDeliveryModeDe;
